module.exports = __webpack_public_path__ + "media/images/icons/mapaDopravnichProudu-b1413209fefb180c7c15244c88978edc.svg";